import React from "react";
import Loader from "../../components/Loader";
import MailingRenderProductItems from "./MailingRenderProductItems";

const HtmlMailingContent = ({
    products = [],
    loading,
    mainImage = [],
    contact = []
}) => {
    const productArray = Array.isArray(products) ? products : [];

    if (loading) return <Loader />;

    return (
        <MailingRenderProductItems
            contact={contact}
            mainImage={mainImage}
            productArray={productArray}
        />
    );
};

export default HtmlMailingContent;